"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asBytes = void 0;
/**
 * Formats `val` as 0x prefixed string with even length
 * @param val
 */
function asBytes(val) {
    const hex = val.toString(16);
    if (hex.length % 2) {
        return '0x0' + hex;
    }
    return '0x' + hex;
}
exports.asBytes = asBytes;
//# sourceMappingURL=as-bytes.js.map